import * as _ from 'lodash'
import {
  IHavePlanMetricsChangedEvent,
  IPlanStandardCalculator, IPlanStandardCalculatorClientExtension, ITPMPlanChangedEvent
} from "../PA.TPM.Core/PA.TPM.IF.TPM.Plan.Aspects";
import {IMessageProvider, IProgressProvider, MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {TPMPlanBO} from "../PA.TPM.BusinessObjects/TPMPlanBO";
import {PlanStandardCalculatorExtDefault} from "./client/PlanStandardCalculatorExtDefault";
import {PlanStandardCalculatorExtProvider} from "./client/PlanStandardCalculatorExtProvider";
import {WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import {Subscription} from "rxjs";
import {IHaveProductGroups} from "../PA.Core/PA.Core.IF.Aspects";
import {CollectionUtils} from "../PA.Core/Basic/Collections";
import {ASync} from "../PA.Core/Basic/ASync";

export class TPMPlanStandardCalculator
  implements  IPlanStandardCalculator {

  private _calcMessageProvider: MessageProvider;
  private _calcProgressProvider: ProgressProvider;
  private _tpmPlanBO: TPMPlanBO

  private _StandardExtension: IPlanStandardCalculatorClientExtension = PlanStandardCalculatorExtDefault
  private _ClientExtension: IPlanStandardCalculatorClientExtension = {id: "client"}
  private _bIsLoaded: boolean

  private _productGroupsLastObservered: WB_ProductGroupRow[]
  private _productGroupsChangedSubscription: Subscription
  private _tpmPlanPropertyChangeSubscription: Subscription
  private _tpmPlanVolumePropertyChangeSubscription: Subscription

  constructor(){
    this._calcMessageProvider = new MessageProvider()
    this._calcProgressProvider = new ProgressProvider()
    this._tpmPlanBO = undefined
    this._bIsLoaded = false
    this._productGroupsLastObservered = []
    this._productGroupsChangedSubscription = undefined

    this._tpmPlanPropertyChangeSubscription = undefined
    this._tpmPlanVolumePropertyChangeSubscription = undefined

  }

  Register(aTPMPlanBO: TPMPlanBO): void {
    const self = this
    const bo = aTPMPlanBO
    // Currently, we don't listen to anything,.. just on demand calc.
    this.UnRegister()
    this._tpmPlanBO = aTPMPlanBO

    if(bo){
      bo.OnLoadComplete
        .then((results) => {

          if(bo.WB_Plan.WB_PlanTypeRow.bUseHyperRectangleInd)
            return undefined

          return PlanStandardCalculatorExtProvider.getPlanStandardCalculatorExtension(bo.WB_Plan.WB_PlanTypeRow.cif.STANDARDCALCULATORCLASS)
        })
        .then((result) => {
          if (!_.isEmpty(result)) {
            self._ClientExtension = result
          } else {
            self._ClientExtension = {id: "none"}
          }
          return bo.OnIHaveProductGroupsLoaded
        })
        .then((results) => {
          this._productGroupsLastObservered = bo.ProductGroups
          this._productGroupsChangedSubscription = bo.ProductGroupsChanged.subscribe(self._OnProductGroupChanged.bind(self))
          this._tpmPlanPropertyChangeSubscription = bo.TPMPlanPropertyChanged.subscribe(this._OnTPMPlanPropertyChanged.bind(self))
          this._tpmPlanVolumePropertyChangeSubscription = bo.PlanVolumeMetricsPropertyChanged.subscribe(this._OnPlanVolumeMetricsPropertyChanged.bind(self))
          // Subscribe

          self._bIsLoaded = true
        })
        .catch((err) => {
          console.log("Error in Standard Calculator Register(): ", err)
          self._bIsLoaded = false
        })
    }
  }

  UnRegister(): void {
    this._tpmPlanBO = undefined
    this._bIsLoaded = false
    if(this._productGroupsChangedSubscription){
      this._productGroupsChangedSubscription.unsubscribe()
    }
    this._productGroupsChangedSubscription = undefined
  }

  private get bIsLoaded(): boolean {
    return this._bIsLoaded
  }


  get CalcProgressProvider(): IProgressProvider {
    return this._calcProgressProvider
  }


  Calculate(): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {

      resolve()
    })
  }

  ApplyBaseline(bIncludePY: boolean, bIncludeAlt: boolean): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {
      if((!self.bIsLoaded) || (!_.isFunction(self._ClientExtension.ApplyBaseline))){
        resolve()
        return
      }

      self._ClientExtension.ApplyBaseline(self._tpmPlanBO, bIncludePY, bIncludeAlt)
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })
  }



  _OnProductGroupChanged(iHaveProductGroups: IHaveProductGroups){
    const self = this
    if(!self.bIsLoaded){ return }


    let currPGs = iHaveProductGroups.ProductGroups
    let delta = CollectionUtils.minus(currPGs, this._productGroupsLastObservered, 'WB_PRDGRP_ID')

    if(delta.length > 0){
      // Fire Product Groups added
      if(_.isFunction(self._ClientExtension.OnProductGroupAdded)){
        //
        self._ClientExtension.OnProductGroupAdded(self._tpmPlanBO)

      }


    }

  }

  _OnTPMPlanPropertyChanged(event: ITPMPlanChangedEvent){
    const self = this

    if(!self.bIsLoaded){ return }
    if(_.isEmpty(event)){ return }

    let beforePromise: Promise<any> = undefined
    //
    switch(true){
      case _.isFunction(self._ClientExtension.OnTPMPlanPropertyChangeBefore):
        beforePromise = self._ClientExtension.OnTPMPlanPropertyChangeBefore(event.TPMPlanBO, event)
        break;
      case _.isFunction(self._StandardExtension.OnTPMPlanPropertyChangeBefore):
        beforePromise = self._StandardExtension.OnTPMPlanPropertyChangeBefore(event.TPMPlanBO, event)
        break;
      default:
        beforePromise = ASync.resolve(true)
    }



    beforePromise
      .then((res) => {
        let propertyChangePromise: Promise<any> = undefined
        switch(true){
          case _.isFunction(self._ClientExtension.OnTPMPlanPropertyChange):
            propertyChangePromise = self._ClientExtension.OnTPMPlanPropertyChange(event.TPMPlanBO, event)
            break;
          case _.isFunction(self._StandardExtension.OnTPMPlanPropertyChange):
            propertyChangePromise = self._StandardExtension.OnTPMPlanPropertyChange(event.TPMPlanBO, event)
            break;
          default:
            propertyChangePromise = ASync.resolve(true)
        }

        return propertyChangePromise
      })
      .then((res) => {
        let afterPromise: Promise<any> = undefined
        switch(true){
          case _.isFunction(self._ClientExtension.OnTPMPlanPropertyChangeAfter):
            afterPromise = self._ClientExtension.OnTPMPlanPropertyChangeAfter(event.TPMPlanBO, event)
            break;
          case _.isFunction(self._StandardExtension.OnTPMPlanPropertyChangeAfter):
            afterPromise = self._StandardExtension.OnTPMPlanPropertyChangeAfter(event.TPMPlanBO, event)
            break;
          default:
            afterPromise = ASync.resolve(true)
        }
        return afterPromise
      })
      .then((res) => {
        // Completed
      })
      .catch((err) => {
        console.log("Standard Calculator TPMPlan Property Change error: ", err)
      })



  }

  _OnPlanVolumeMetricsPropertyChanged(event: IHavePlanMetricsChangedEvent){
    const self = this

    if(!self.bIsLoaded){ return }
    if(_.isEmpty(event)){ return }

    let beforePromise: Promise<any> = undefined
    //
    switch(true){
      case _.isFunction(self._ClientExtension.OnTPMPlanVolumeMetricPropertyChangeBefore):
        beforePromise = self._ClientExtension.OnTPMPlanVolumeMetricPropertyChangeBefore(<TPMPlanBO> event.IHavePlanVolumeMetrics, event)
        break;
      case _.isFunction(self._StandardExtension.OnTPMPlanVolumeMetricPropertyChangeBefore):
        beforePromise = self._StandardExtension.OnTPMPlanVolumeMetricPropertyChangeBefore(<TPMPlanBO> event.IHavePlanVolumeMetrics, event)
        break;
      default:
        beforePromise = ASync.resolve(true)
    }



    beforePromise
      .then((res) => {
        let propertyChangePromise: Promise<any> = undefined
        switch(true){
          case _.isFunction(self._ClientExtension.OnTPMPlanVolumeMetricPropertyChange):
            propertyChangePromise = self._ClientExtension.OnTPMPlanVolumeMetricPropertyChange(<TPMPlanBO> event.IHavePlanVolumeMetrics, event)
            break;
          case _.isFunction(self._StandardExtension.OnTPMPlanVolumeMetricPropertyChange):
            propertyChangePromise = self._StandardExtension.OnTPMPlanVolumeMetricPropertyChange(<TPMPlanBO> event.IHavePlanVolumeMetrics, event)
            break;
          default:
            propertyChangePromise = ASync.resolve(true)
        }

        return propertyChangePromise
      })
      .then((res) => {
        let afterPromise: Promise<any> = undefined
        switch(true){
          case _.isFunction(self._ClientExtension.OnTPMPlanVolumeMetricPropertyChangeAfter):
            afterPromise = self._ClientExtension.OnTPMPlanVolumeMetricPropertyChangeAfter(<TPMPlanBO> event.IHavePlanVolumeMetrics, event)
            break;
          case _.isFunction(self._StandardExtension.OnTPMPlanVolumeMetricPropertyChangeAfter):
            afterPromise = self._StandardExtension.OnTPMPlanVolumeMetricPropertyChangeAfter(<TPMPlanBO> event.IHavePlanVolumeMetrics, event)
            break;
          default:
            afterPromise = ASync.resolve(true)
        }
        return afterPromise
      })
      .then((res) => {

      })
      .catch((err) => {
        console.log("Standard Calculator TPMPlanVolumeMetric Property Change error: ", err)
      })




  }


}
